import { useGlobal } from '../../hooks';
import styled from '@emotion/styled';
import { ContactUs, ShareEmail, SharePhone, ShareViaBrowser } from './Buttons';
import { normalizeLinks } from 'rwl-ui/src/utils/normalizeContactLinks';

const CTABarContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    padding: var(--rwl-spacing-md);
    gap: var(--rwl-spacing-md);
`;

type CTABarProps = {
    mediaId?: string;
    workSiteId?: string;
};

export const CTABar = ({ ...ids }: CTABarProps) => {
    const { config } = useGlobal();

    if (!config) {
        return <CTABarContainer />;
    }

    const { contactUs, email, phoneNumber } = normalizeLinks(
        config?.businessContactInfo
    );

    let noCTA = false;
    if (!contactUs && !email && !phoneNumber) {
        noCTA = true;
    }

    return (
        <CTABarContainer
            className={noCTA ? 'rwlNoCTASetup' : 'rwlCTAContainer'}
        >
            <ShareEmail email={email} {...ids} />
            <SharePhone phoneNumber={phoneNumber} {...ids} />
            <ShareViaBrowser accountName={config?.account.name} {...ids} />
            <ContactUs link={contactUs} {...ids} />
        </CTABarContainer>
    );
};
